export default "__VITE_ASSET__CdxoyyLr__"